<template>
  <Modal
    ref="modal"
    title="Einzelversand an Beschenkte"
    class="modal-shipping-individual"
  >
    <template v-slot:content>
      <p class="u-text-dimmed">Bei dieser Versandart werden die <b>{{ $store.getters.getSelectedQty }} Präsente</b> an <b>{{ $store.getters.getSelectedQty }} unterschiedliche Anschriften gesendet</b> - im Regelfall direkt an die Beschenkten. Dies können sowohl Firmen- als auch Privatadressen sein.</p>

      <FlashMessage
        v-if="$parent.errors.length"
        type="error"
      >
        <p>{{ $parent.errors[0].message }}</p>
      </FlashMessage>

      <!-- DE -->
      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <div class="shipping__icon">
            <img src="@/assets/images/landing-page/flags/de.svg" alt="Deutschland Flag">
          </div>

          <div class="shipping__label">
            Deutschland
            <small v-if="$store.getters.isB2b">5,90 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(5.9) }} inkl. MwSt.</span></small>
            <small v-else>{{ splittedTaxSingle(5.9) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">5,90 € zzgl. MwSt.</span></small>
          </div>
        </div>

        <div class="shipping__select">
          <FormSelect @change="(v) => selectionData.individual.regions.de = parseInt(v)">
            <option value="0" :selected="selectionData.individual.regions.de === 0">0</option>
            <option v-for="i in Math.max(0, boxQty - selectionData.individual.regions.eu - selectionData.individual.regions.ch_uk - selectionData.individual.regions.other)" :key="i" :value="i" :selected="selectionData.individual.regions.de === i">{{ i }}</option>
          </FormSelect>

          Präsente
        </div>
      </div>
      <!-- /DE -->

      <!-- EU -->
      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <div class="shipping__icon">
            <img src="@/assets/images/landing-page/flags/eu.svg" alt="Europe Flag">
          </div>

          <div class="shipping__label">
            Europa
            <small v-if="$store.getters.isB2b">13,50 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(13.5) }} inkl. MwSt.</span></small>
            <small v-else>{{ splittedTaxSingle(13.5) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">13,50 € zzgl. MwSt.</span></small>
          </div>
        </div>

        <div class="shipping__select">
          <FormSelect @change="(v) => selectionData.individual.regions.eu = parseInt(v)">
            <option value="0" :selected="selectionData.individual.regions.eu === 0">0</option>
            <option v-for="i in Math.max(0, boxQty - selectionData.individual.regions.de - selectionData.individual.regions.ch_uk - selectionData.individual.regions.other)" :key="i" :value="i" :selected="selectionData.individual.regions.eu === i">{{ i }}</option>
          </FormSelect>

          Präsente
        </div>
      </div>
      <!-- /EU -->

      <!-- CN, UK -->
      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <div class="shipping__icon --has-multiple-flags">
            <img src="@/assets/images/landing-page/flags/ch.svg" alt="Switzerland Flag">
            <img src="@/assets/images/landing-page/flags/uk.svg" alt="United Kingdom Flag">
          </div>

          <div class="shipping__label">
            Schweiz / UK
            <small v-if="$store.getters.isB2b">35,00 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(35.0) }} inkl. MwSt.</span></small>
            <small v-else>{{ splittedTaxSingle(35.0) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">35,00 € zzgl. MwSt.</span></small>
          </div>
        </div>

        <div class="shipping__select">
          <FormSelect @change="(v) => selectionData.individual.regions.ch_uk = parseInt(v)">
            <option value="0" :selected="selectionData.individual.regions.ch_uk === 0">0</option>
            <option v-for="i in Math.max(0, boxQty - selectionData.individual.regions.de - selectionData.individual.regions.eu - selectionData.individual.regions.other)" :key="i" :value="i" :selected="selectionData.individual.regions.ch_uk === i">{{ i }}</option>
          </FormSelect>

          Präsente
        </div>
      </div>
      <!-- /CN, UK -->

      <!-- Other -->
      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <div class="shipping__icon">
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#B7ECEC"/><path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66659 27.7333L7.99992 21H9.43992C9.74402 21.001 10.0443 20.9318 10.3172 20.7976C10.5901 20.6635 10.8283 20.4681 11.0133 20.2267C11.2037 19.9908 11.3357 19.7132 11.3982 19.4166C11.4608 19.1199 11.4522 18.8127 11.3733 18.52L10.3733 14.52C10.2685 14.0864 10.0208 13.7006 9.67005 13.4249C9.31935 13.1492 8.88604 12.9995 8.43992 13H1.33325" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.9999 7H22.5599C22.1137 6.9995 21.6804 7.14916 21.3297 7.42489C20.979 7.70062 20.7313 8.08636 20.6265 8.52L19.6265 12.52C19.5493 12.8137 19.5429 13.1216 19.6078 13.4183C19.6727 13.7149 19.8071 13.992 19.9999 14.2267C20.1848 14.4681 20.423 14.6635 20.6959 14.7976C20.9688 14.9318 21.2691 15.001 21.5732 15H23.6799L24.7199 21.3333C24.7979 21.7951 25.0354 22.2148 25.3912 22.5194C25.7469 22.824 26.1982 22.9941 26.6665 23H29.3332" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="shipping__label">
            Andere Länder

            <small v-if="$store.getters.isB2b">45,00 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(45.0) }} inkl. MwSt.</span></small>
            <small v-else>{{ splittedTaxSingle(45.0) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">45,00 € zzgl. MwSt.</span></small>
            <span class="shipping__additional_info">Lieferungen in die Türkei und nach Paraguay können aktuell nicht durchgeführt werden.</span>
          </div>
        </div>

        <div class="shipping__select">
          <FormSelect @change="(v) => selectionData.individual.regions.other = parseInt(v)">
            <option value="0" :selected="selectionData.individual.regions.other === 0">0</option>
            <option v-for="i in Math.max(0, boxQty - selectionData.individual.regions.eu - selectionData.individual.regions.ch_uk - selectionData.individual.regions.de)" :key="i" :value="i" :selected="selectionData.individual.regions.other === i">{{ i }}</option>
          </FormSelect>

          Präsente
        </div>
      </div>
      <!-- /Other -->
      <p class="u-text-dimmed">Die angegebenen Kosten enthalten neben dem reinen Porto auch die Versandverpackung (z.B. Kartons, Füllmaterial) sowie deren Handling.</p>
      <Notice>
        <template v-slot:icon>
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M9.000 7.500 A3.000 3.000 0 1 0 15.000 7.500 A3.000 3.000 0 1 0 9.000 7.500 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12,.75A6.75,6.75,0,0,1,18.75,7.5c0,3.251-5.132,10.527-6.446,12.337a.377.377,0,0,1-.608,0C10.382,18.027,5.25,10.751,5.25,7.5A6.75,6.75,0,0,1,12,.75Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.979,17.784c2.732.541,4.521,1.444,4.521,2.466,0,1.657-4.7,3-10.5,3s-10.5-1.343-10.5-3c0-1.02,1.781-1.921,4.5-2.463" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
        </template>

        <p>Die Eingabe erfolgt mit Hilfe einer Excel-Vorlage, welche Sie nach der Bestellung per eMail erhalten.</p>
      </Notice>
    </template>

    <template v-slot:footer>
      <Button
        @click="submit()"
        appearance="primary"
      >
        Auswahl bestätigen
      </Button>

      <Button
        @click="$refs.modal.close()"
        appearance="secondary"
      >
        Abbrechen
      </Button>
    </template>
  </Modal>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import Modal from '@/components/Composer/Modal';
import Button from '@/components/Common/Button';
import Notice from '@/components/Composer/Notice';
import FormSelect from '@/components/Common/FormSelect';
import FlashMessage from '@/components/Composer/FlashMessage';

export default {
  name: 'ModalShippingIndividual',
  props: {
    selectionData: {
      type: Object
    }
  },
  mixins: [logicMixin],
  components: {
    Modal,
    Button,
    Notice,
    FormSelect,
    FlashMessage
  },
  methods: {
    submit () {
      this.selectionData.main.mode = 3;
      this.selectionData.individual.international = this.selectionData.individual.regions.eu > 0 || this.selectionData.individual.regions.other > 0 || this.selectionData.individual.regions.ch_uk > 0;

      this.$refs.modal.close({
        submit: true
      });
    }
  },
  mounted() {
    if (this.selectionData.individual.regions.de === 0 && this.selectionData.individual.regions.eu === 0 && this.selectionData.individual.regions.other === 0 && this.selectionData.individual.regions.ch_uk === 0) {
      this.selectionData.individual.regions.de = this.boxQty;
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * ModalShippingIndividual
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Individual Shipping Options
 * @since 2022-09-07
**/

$component: 'modal-shipping-individual';

.#{$component} {
  //…

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
